import { render } from "./FeedbackModal.vue?vue&type=template&id=243b9c2a&scoped=true"
import script from "./FeedbackModal.vue?vue&type=script&lang=js"
export * from "./FeedbackModal.vue?vue&type=script&lang=js"

import "./FeedbackModal.vue?vue&type=style&index=0&id=243b9c2a&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243b9c2a"]])

export default __exports__